/**
 * This Outlook window's voice id (outlook-orachat-uplift s9, AD-2).
 *
 * One id per page load, only in memory. A second window loads the module
 * again and gets a different id. It rides the voice routes only — never a
 * chat request — and the server ignores it on speech-to-text.
 */

const WINDOW_ID = /^[A-Za-z0-9-]{8,64}$/;

function fallbackWindowId(): string {
  const bytes = new Uint8Array(16);
  const cryptoObj = globalThis.crypto;
  if (cryptoObj?.getRandomValues) cryptoObj.getRandomValues(bytes);
  else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

function freshWindowId(): string {
  try {
    const id = globalThis.crypto?.randomUUID?.();
    if (typeof id === "string" && WINDOW_ID.test(id)) return id;
  } catch {
    // No randomUUID in this host: the hex fallback below still matches the claim shape.
  }
  const fallback = fallbackWindowId();
  return WINDOW_ID.test(fallback) ? fallback : "window-instance-fallback";
}

/** Stable for this page. A reload or another window mints a new one. */
export const ADDIN_WINDOW_INSTANCE = freshWindowId();
